import { Link } from 'react-router-dom';
import { Button, Card } from '../components/ui';

export default function NotFoundPage(): JSX.Element {
  return (
    <div className="mx-auto flex min-h-[60vh] max-w-2xl items-center px-4 py-16 text-center sm:px-6 lg:px-8">
      <Card variant="elevated" className="w-full py-10">
        <span className="text-sm font-semibold uppercase tracking-widest text-brand-carnaby-pink">
          404
        </span>
        <h1 className="mt-2 text-3xl font-semibold tracking-tight text-text-primary sm:text-4xl">
          We couldn&rsquo;t find that page
        </h1>
        <p className="mx-auto mt-4 max-w-md text-sm text-text-secondary">
          The link might be broken or the page may have moved. From here you can head back to the
          home page or explore the latest open roles.
        </p>
        <div className="mt-8 flex flex-col justify-center gap-2 sm:flex-row">
          <Link to="/">
            <Button variant="secondary">Back to home</Button>
          </Link>
          <Link to="/">
            <Button>Browse jobs</Button>
          </Link>
        </div>
      </Card>
    </div>
  );
}
